<template>
  <div>
    <profilesPage
      :loading="loading"
      :path="path"
      :title="title"
      :create-btn="createBtn"
      :select="select"
      :select-options="selectOptions"
      :fields="fields"
      :items="items"
      :name="name"
      :pageTotal="pageTotal"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @handleSearch="handleSearch"
      :currentPage="currentPage"
      :rows="rows"
      :sort="sort"
      :direct="direct"
      @orderHead="orderHead"
      @selectFilmType="selectFilmType"
    />
  </div>
</template>

<script>
import profilesPage from '../profilespage/profilesPage'
import { getDirectorApi } from '@/api/film-material-management/director'

export default {
  components: {
    profilesPage,
  },
  data() {
    return {
      sort: 'id',
      direct: 'desc',
      loading: false,
      title: '導演',
      name: 'Director',
      createBtn: '創立新導演記錄',
      select: '',
      path: '/dashboard/director-info',
      selectOptions: ['香港', '非香港'],
      currentPage: 1,
      fields: [
        {
          key: 'id',
          label: 'Director ID',
          sortKey: 'id',
        },
        {
          key: 'name_en',
          label: 'Director Name',
          sortKey: 'director_name_en',
        },
        {
          key: 'name_cn',
          label: '導演名稱',
          sortKey: 'director_name_zh_hk',
        },
        {
          key: 'action',
          label: '',
        },
      ],
      items: [],
      pageTotal: 10,
      rows: 20,
      search: '',
      location: '',
      isOld: 0,
    }
  },
  methods: {
    selectFilmType(val) {
      this.isOld = val
      this.getDirectorList()
    },
    orderHead(key, direct) {
      this.sort = key
      this.direct = direct
      this.getDirectorList()
    },
    handleSizeChange(val) {
      this.rows = val
      this.getDirectorList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getDirectorList()
    },
    handleSearch(val) {
      this.currentPage = 1
      this.rows = val.rows
      this.location = val.selectArea
      this.search = val.search
      this.sort = val.sort
      this.direct = val.direct
      this.getDirectorList()
    },
    getDirectorList() {
      this.loading = true
      const data = {
        page: this.currentPage,
        count: this.rows,
        area: this.location,
        search: this.search,
        sort: this.sort,
        direct: this.direct,
        arch: this.isOld,
      }
      getDirectorApi(data)
        .then((res) => {
          this.items = res.data
          this.pageTotal = res.total
          const arr = []
          this.items.forEach((el) => {
            const obj = new Object()
            obj.id = el.id
            obj.name_cn = el.director_name_zh_hk
            obj.name_en = el.director_name_en
            obj.name_other = el.director_name_other
            obj.area = el.area
            arr.push(obj)
          })
          this.items = arr
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
  mounted() {
    this.getDirectorList()
  },
}
</script>

<style lang="scss" scoped>
</style>
